import { motion } from "framer-motion";
import React, { forwardRef } from "react";
import { getIconCategory } from "../../utils/utils";

const Category = forwardRef(({ name, icon, isSelected, onClick, size = "md" }, ref) => {
    const Icon = getIconCategory(icon);

    // Mappatura delle classi in base alla dimensione con stile Dark Premium
    const sizeClasses = {
        md: {
            container: "min-w-[76px] px-1",
            circle: "w-14 h-14",
            icon: "w-6 h-6",
            text: "text-[11px] font-bold mt-2 tracking-wide",
        },
        lg: {
            container: "min-w-[90px]",
            circle: "w-16 h-16", // Ottimizzato per la griglia senza occupare spazio inutile
            icon: "w-7 h-7",
            text: "text-xs font-black mt-2.5 tracking-wider uppercase",
        }
    };

    const currentSize = sizeClasses[size] || sizeClasses.md;

    return (
        <button
            ref={ref}
            onClick={onClick}
            className={`flex flex-col items-center justify-center focus:outline-none select-none transition-opacity duration-200 active:opacity-80 ${currentSize.container}`}
        >
            <motion.div
                animate={isSelected ? { scale: 1.1, y: -2 } : { scale: 1, y: 0 }}
                transition={{ type: "spring", stiffness: 350, damping: 18 }}
                className={`flex items-center justify-center rounded-full border transition-colors duration-300 ${currentSize.circle} ${
                    isSelected 
                        ? "border-primary bg-primary/10 shadow-[0_0_20px_rgba(233,69,69,0.2)]" 
                        : "border-accent/30 bg-[#121824]/60 shadow-md group-hover:border-accent/60"
                }`}
            >
                {Icon && React.cloneElement(Icon, { 
                    className: `${currentSize.icon} transition-colors duration-300 ${
                        isSelected ? "text-primary stroke-[2.5]" : "text-muted/80 stroke-[2]"
                    }` 
                })}
            </motion.div>
            
            <span
                className={`text-center truncate w-full transition-colors duration-300 ${currentSize.text} ${
                    isSelected ? "text-primary" : "text-muted/90"
                }`}
            >
                {name}
            </span>
        </button>
    );
});

Category.displayName = "Category";

export default Category;